module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "member"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.userInfo.nickname) + "\n  ")]), _vm._v(" "), (_vm.userInfo && _vm.userInfo.level_pic_three.length > 0) ? _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.level_pic_three,
      "alt": "",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_vm._v("已打败" + _vm._s(_vm.userInfo.win_user * 100) + "%的用户")])]), _vm._v(" "), _c('div', {
    staticClass: "medal"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.medal_three,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "exp"
  }, [_c('div', {
    staticStyle: {
      "font-size": ".24rem"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.exp))]), _vm._v("/" + _vm._s(_vm.userInfo.next_level_exp))]), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('div', {
    style: ({
      width: _vm.userInfo.expPecent
    })
  })]), _vm._v(" "), _c('div', [_vm._v("再获取" + _vm._s(_vm.userInfo.need_exp) + "经验值可升级")])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold fs-24"
  }, [_c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.join_aly_day))]), _vm._v("天")]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("加入俺来也")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold fs-24"
  }, [_c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.order_time))]), _vm._v("次")]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("累计下单")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("¥"), _c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.order_money))])]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("累计消费")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "get-ways"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("2021年01月08日生效")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.viewExp()
      }
    }
  }, [_vm._v("查看升级所需经验")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/get-ways.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-qiandao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("每日签到")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+5")]), _vm._v("经验/天，连续签到"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+8")]), _vm._v("经验/天")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-xndc.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("校内订餐")]), _vm._v(" "), _c('p', [_vm._v("每单每元"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+1")]), _vm._v("经验，上限"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验/单")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-ddpj.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("订单评价")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+5")]), _vm._v("经验/每单评价")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-wstx.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("完善社区资料头像昵称")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验，仅限获得一次")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-xxx.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("申请西游侠")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+20")]), _vm._v("经验")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/icon-mrsd.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("每日送单")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+2")]), _vm._v("经验，上限"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-45c4701c","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/MemberLevel.vue
// module id = 429
// module chunks = 7